// Black Dog Society — the artist's inner world, rendered in ink.

// Brand marks
export const LOGO_URL = "https://customer-assets-39nsmqrw.emergentagent.net/job_bds-3d-motion/artifacts/68r14hl0_48F4A674-3408-48B9-B89F-976865E5A31F.jpeg";
export const SYMBOL_URL = "https://customer-assets-39nsmqrw.emergentagent.net/job_bds-3d-motion/artifacts/7gungch8_48F4A674-3408-48B9-B89F-976865E5A31F%203.jpeg";
export const TAGLINE = "Face your demons. Wear your story.";


export const ARTWORKS = [
  {
    id: "bloom",
    index: "01",
    title: "Bloom",
    subtitle: "Screaming Sunflower",
    note: "Growth is not always gentle. Sometimes it screams from the root.",
    img: `/art/bloom.png`,
  },
  {
    id: "the-quiet-one",
    index: "02",
    title: "The Quiet One",
    subtitle: "Study of a Watcher",
    note: "Big eyes, small voice. The part of us that only observes.",
    img: `/art/the-quiet-one.png`,
  },
  {
    id: "static",
    index: "03",
    title: "Static",
    subtitle: "A Face in the Noise",
    note: "The overwhelm. Every thought at once, drawn dot by dot.",
    img: `/art/static.png`,
  },
];

// Held back for Chapter II — hidden from the pre-launch Gallery for now.
export const CHAPTER_II_ARTWORKS = [
  {
    id: "the-keeper",
    index: "01",
    title: "The Keeper",
    subtitle: "Fancy Key Man",
    note: "The face that guards the door you're afraid to open.",
    img: `/art/the-keeper.png`,
  },
];

export const CHAPTERS = [
  {
    n: "01",
    title: "The black dog has a name",
    body: "Depression, anxiety, the weight you carry silently — Winston Churchill called his the black dog. We wear ours on the outside so no one has to carry it alone.",
  },
  {
    n: "02",
    title: "We draw what we can't say",
    body: "Every piece begins in the chaos — the nights the mind won't go quiet. The monsters, the flowers with faces, the keys to locked rooms. This is language for feelings that don't have words yet.",
  },
  {
    n: "03",
    title: "Wearing it is the conversation",
    body: "You put on the piece. Someone asks about it. Suddenly you're talking. That's the whole point — clothing as a door into the conversations we avoid.",
  },
  {
    n: "04",
    title: "A society, not a store",
    body: "A portion of every drop funds mental-health support. You're not a customer. You're a member of a quiet society that decided to stop pretending it's fine.",
  },
];

// ---- Store: Inner Demons — Vol. 1 ----
export const PRODUCTS = [
  {
    lookup_key: "bds_watcher_tee",
    name: "The Watcher Tee",
    edition: "01 — Inner Demons Vol. 1",
    wash: "Vintage Black",
    price: 65,
    fabric: "450gsm heavyweight cotton · oversized box fit · screen + puff print · vintage wash",
    quote: "It watches from behind your eyes, and never blinks.",
    card: "/products/watcher_back.png",
    images: [
      "/products/watcher_back.png",
      "/products/watcher_front.png",
      "/products/watcher_model_back.png",
      "/products/watcher_model_front.png",
    ],
  },
  {
    lookup_key: "bds_rooted_tee",
    name: "Rooted Fear Tee",
    edition: "02 — Inner Demons Vol. 1",
    wash: "Vintage Cream",
    price: 65,
    fabric: "450gsm heavyweight cotton · oversized box fit · screen print · vintage wash",
    quote: "What grows inside you never leaves.",
    card: "/products/rooted_back.png",
    images: [
      "/products/rooted_back.png",
      "/products/rooted_front.png",
      "/products/rooted_model_back.png",
      "/products/rooted_model_front.png",
    ],
  },
  {
    lookup_key: "bds_crawler_hoodie",
    name: "The Crawler Hoodie",
    edition: "03 — Inner Demons Vol. 1",
    wash: "Washed Black",
    price: 145,
    fabric: "450gsm heavyweight cotton · oversized fit · embroidery + screen print · vintage wash",
    quote: "The thing you buried learned to crawl.",
    card: "/products/crawler_back.png",
    images: [
      "/products/crawler_back.png",
      "/products/crawler_front.png",
      "/products/crawler_model_back.png",
      "/products/crawler_model_front.png",
    ],
  },
];

export const RITUAL_SET = {
  lookup_key: "bds_ritual_set",
  name: "The Complete Ritual",
  edition: "The Full Uniform — Inner Demons Vol. 1",
  tagline: "Four pieces. One offering to the self.",
  price: 199,
  original: 290,
  save: 91,
  wash: "Washed Black · Vintage",
  quote: "You do not fight the dog. You walk beside it — dressed for the vigil.",
  fabric: "The Crawler Hoodie + The Watcher Tee + The Society Cap + Society Socks. Includes 1 complimentary sealed Vault card. Apparel size applies to hoodie & tee.",
  card: "/products/crawler_back.png",
  contents: [
    { name: "The Crawler Hoodie", price: 145, img: "/products/crawler_back.png" },
    { name: "The Watcher Tee", price: 65, img: "/products/watcher_back.png" },
    { name: "The Society Cap", price: 55, img: "/objects/hat.png" },
    { name: "Society Socks", price: 25, img: "/objects/socks.png" },
  ],
};

export const SIZES = ["XS", "S", "M", "L", "XL", "XXL"];

// Premium packaging — The Society Kit
export const PACKAGING = [
  {
    img: "/packaging/box.jpg",
    title: "The Society Box",
    note: "Matte-black rigid box, debossed BDS mark. Built to keep.",
  },
  {
    img: "/packaging/tissue.jpg",
    title: "Wax-Sealed Tissue",
    note: "Emblem-printed tissue, bound with a hand-pressed wax seal.",
  },
  {
    img: "/packaging/cards.jpg",
    title: "Member Card & Note",
    note: "A numbered Society membership card and a hand-set welcome note.",
  },
];

// ---- Fragrances: The Inner Demons — Eau de Parfum ----
export const FRAGRANCE_GALLERY = [
  { img: "/fragrances/packaging.png", label: "Premium Packaging" },
  { img: "/fragrances/details.png", label: "The Details" },
  { img: "/fragrances/collection.png", label: "The Collection" },
];

export const FRAGRANCES = [
  {
    lookup_key: "bds_edp_watcher",
    roman: "I",
    name: "The Watcher",
    price: 129,
    img: "/fragrances/watcher.png",
    video: "/videos/scent_watcher.mp4",
    notes: "Bergamot · Black Pepper · Juniper · Incense · Vetiver · Cedar · Smoke",
    story: "Sharp and unblinking. The scent of being seen — cold incense over smoked cedar, worn like a stare you can't shake.",
    top: ["Bergamot", "Black Pepper"],
    mid: ["Juniper", "Incense"],
    base: ["Vetiver", "Cedar", "Smoke"],
  },
  {
    lookup_key: "bds_edp_rooted",
    roman: "II",
    name: "Rooted Fear",
    price: 129,
    img: "/fragrances/rooted.png",
    video: "/videos/scent_rooted.mp4",
    notes: "Oakmoss · Cypress · Wet Earth · Sandalwood · Leather · Patchouli",
    story: "Damp earth and old wood. What grows inside you never leaves — mossy, green, and rooted deep.",
    top: ["Cypress", "Wet Earth"],
    mid: ["Oakmoss", "Patchouli"],
    base: ["Sandalwood", "Leather"],
  },
  {
    lookup_key: "bds_edp_crawler",
    roman: "III",
    name: "The Crawler",
    price: 129,
    img: "/fragrances/crawler.png",
    video: "/videos/scent_crawler.mp4",
    notes: "Tobacco · Rum · Vanilla · Amber · Oud · Charred Woods",
    story: "Warm, buried, and crawling back to the surface — spiced rum and tobacco over charred, resinous woods.",
    top: ["Rum", "Tobacco"],
    mid: ["Vanilla", "Amber"],
    base: ["Oud", "Charred Woods"],
  },
  {
    lookup_key: "bds_edp_rebirth",
    roman: "IV",
    name: "Rebirth",
    price: 129,
    img: "/fragrances/rebirth.png",
    video: "/videos/scent_rebirth.mp4",
    notes: "Bright Woods · White Musk · Amber · Soft Smoke",
    story: "The clean light of the morning after the dark — bright woods and white musk wrapped in soft amber smoke.",
    top: ["Bright Woods"],
    mid: ["White Musk", "Amber"],
    base: ["Amber", "Soft Smoke"],
  },
];

// ---- Collectable Cards — The Vault ----
export const CARD_PRODUCTS = [
  { lookup_key: "bds_mystery_card", name: "Mystery Card", price: 25, sub: "One sealed, random serial", grants: 1 },
  { lookup_key: "bds_card_bundle", name: "Pack of Three", price: 60, sub: "Three random serials · save NZ$15", grants: 3 },
];

export const CARD_TIERS = [
  { name: "Origin", range: "001 – 005", note: "Ultra rare. The founding five.", accent: "#C9A227" },
  { name: "Rare", range: "006 – 025", note: "Twenty of them exist.", accent: "#8B3A2B" },
  { name: "Uncommon", range: "026 – 060", note: "Harder to find than most.", accent: "#5B6B73" },
  { name: "Society", range: "061 – 100", note: "The body of the Society.", accent: "#8A8A93" },
];

// ---- Objects: candles & incense (simple), hats & socks (style variants) ----
export const OBJECTS = [
  {
    lookup_key: "bds_candle",
    name: "Vigil Candle",
    price: 65,
    img: "/objects/candle.png",
    type: "Soy Wax · ~45h burn",
    blurb: "Matte-black debossed vessel. Cypress, wet earth and soft smoke — Rooted Fear, for the room.",
    size: "220g",
  },
  {
    lookup_key: "bds_incense",
    name: "Ritual Incense",
    price: 35,
    img: "/objects/incense.png",
    type: "Hand-dipped · Cast Holder",
    blurb: "Hand-dipped incense with a cast thorn-star holder. Incense, cedar and smoke.",
    size: "20 Sticks",
  },
];

// Hats & socks with selectable style variants (same price/SKU, style stored as meta)
export const VARIANT_PRODUCTS = [
  {
    lookup_key: "bds_hat",
    name: "The Society Cap",
    price: 55,
    base: "Washed Black · Structured 6-panel · One size",
    card: "/objects/hat.png",
    variants: [
      { id: "emblem", label: "Emblem", img: "/objects/hat.png" },
      { id: "wordmark", label: "Wordmark", img: "/objects/hat_wordmark.png" },
      { id: "logo", label: "Logo", img: "/objects/hat_logo.png" },
      { id: "art", label: "Art Panel", img: "/objects/hat_art.png" },
    ],
  },
  {
    lookup_key: "bds_socks",
    name: "Society Socks",
    price: 25,
    base: "Ribbed combed-cotton crew · One size",
    card: "/objects/socks.png",
    variants: [
      { id: "emblem", label: "Emblem", img: "/objects/socks.png" },
      { id: "wordmark", label: "Wordmark", img: "/objects/socks_wordmark.png" },
      { id: "logo", label: "Logo", img: "/objects/socks_logo.png" },
      { id: "art", label: "Art Side", img: "/objects/socks_art.png" },
    ],
  },
];

// Cross-sell recommendations for "Complete the Ritual"
export const RECOMMENDATIONS = [
  { lookup_key: "bds_candle", name: "Vigil Candle", price: 65, img: "/objects/candle.png", wash: "Soy Wax · ~45h burn", size: "220g" },
  { lookup_key: "bds_incense", name: "Ritual Incense", price: 35, img: "/objects/incense.png", wash: "Hand-dipped · Cast Holder", size: "20 Sticks" },
  { lookup_key: "bds_mystery_card", name: "Collectable Card", price: 25, img: SYMBOL_URL, wash: "One sealed, random serial", size: "" },
  { lookup_key: "bds_hat", name: "The Society Cap", price: 55, img: "/objects/hat.png", wash: "Emblem · Washed Black", size: "Emblem" },
];




